export default {
  operations: {
    monedaExtranjera: { label: 'No', value: false },
    productMonedaExtranjera: { label: 'No', value: false },
    transationType: '',
    banco: '',
    cual: '',
    numProducto: '',
    tipoProducto: '',
    pais: '',
    montoOperacional: '',
    moneda: '',
    ciudad: '',
  },
  politicallyExposedPerson: {
    publicStaff: { label: 'No', value: false },
    managePublicResources: { label: 'No', value: false },
    politicallyExposed: { label: 'No', value: false },
    politicallyExposedRelatives: { label: 'No', value: false },
    fecha: ''
  },
  relatives:[{ id: 0, nombres: '', apellidos: '', parentesco: '', showParentesco: false, filteredParentescos: [] }]
}
